class TokenClaimDto {
    username: string;
    email: string;
    userid: string;
    iss: string;
    aud: string;
    iat: number;
    exp: number;
    sub: string;
    auth_time: number;
    sid: string;
}

export default TokenClaimDto;